var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMkNorthMacedonia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#D20000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H51L30 21.6937L9 0H0L60 45H51L30 23.3063L9 45H0L60 0ZM0 18V27L60 18V27L0 18ZM33.75 0L30 19.2844L26.25 0H33.75ZM33.75 45L30 25.7156L26.25 45H33.75Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0004 29.7282C26.0084 29.7282 22.7723 26.4921 22.7723 22.5001C22.7723 18.5081 26.0084 15.272 30.0004 15.272C33.9924 15.272 37.2285 18.5081 37.2285 22.5001C37.2285 26.4921 33.9924 29.7282 30.0004 29.7282Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9996 16.0733C33.5489 16.0733 36.4262 18.9506 36.4262 22.4999C36.4262 26.0492 33.5489 28.9265 29.9996 28.9265C26.4503 28.9265 23.573 26.0492 23.573 22.4999C23.573 18.9506 26.4503 16.0733 29.9996 16.0733ZM38.0293 22.4999C38.0293 18.0652 34.4343 14.4702 29.9996 14.4702C25.5649 14.4702 21.9699 18.0652 21.9699 22.4999C21.9699 26.9346 25.5649 30.5296 29.9996 30.5296C34.4343 30.5296 38.0293 26.9346 38.0293 22.4999Z",
    fill: "#D20000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMkNorthMacedonia);
export default __webpack_public_path__ + "static/media/mk North Macedonia.069c8c6b15709d59dc58e91534a6a16a.svg";
export { ForwardRef as ReactComponent };